import { type TipTapDoc } from "@compass/shared/schema/tiptapDoc";
import { type Editor } from "@tiptap/react";
import React, { useCallback, useEffect, useState } from "react";
import { PostEditor } from "../PostEditor";

interface PropsAskMeAbout {
    setEditorContent: (doc: TipTapDoc) => void;
    initialContent?: TipTapDoc | null;
}

export const AskMeAbout = ({ setEditorContent, initialContent }: PropsAskMeAbout) => {
    const [editor, setEditor] = useState<Editor | null>(null);
    const editorRef = useCallback((editorInstance: Editor | null) => {
        if (editorInstance) {
            setEditor(editorInstance);
        }
    }, []);

    useEffect(() => {
        if (!editor) return;
        if (initialContent) {
            editor?.commands.setContent(initialContent);
        }
    }, [editor, initialContent]);

    return (
        <div className="bg-brand-polar col-start-1 col-end-4 rounded-2xl border border-[#c8c8c8] p-6 shadow-none">
            <div className="text-lg font-semibold">Ask me about...</div>
            <div className="mt-4">
                <div className="min-h-[180px] w-full rounded-md border">
                    <PostEditor
                        initialValue={initialContent}
                        onChange={setEditorContent}
                        placeholder={"Ask me about..."}
                        ref={editorRef}
                    />
                </div>
            </div>
        </div>
    );
};
